var style = {"socialLogin":"SocialLogin-module_socialLogin__toLxz","socialButton":"SocialLogin-module_socialButton__82EVd","text":"SocialLogin-module_text__9PIwH","socialIcon":"SocialLogin-module_socialIcon__M4SoM","google":"SocialLogin-module_google__5oKNK"};

export { style as default };
//# sourceMappingURL=SocialLogin.module.scss.js.map
